import Vue from 'vue'
import Vuex from 'vuex'
import sectionsModule from './modules/sections'
import resultsModule from './modules/results'
import appModule from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    sections: sectionsModule,
    results: resultsModule,
    app: appModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js